<template>
  <div class="page">
    <!-- :bodyStyle="{padding:'12px'}" -->
    <a-card title="授信还款" :bordered="false" :bodyStyle="{paddingTop:'0px'}"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}">
      <a-row>
        <a-col :span="12">
          <a-form @submit="handleSubmit" :form="form">
            <a-row class="title-name">当前待还款 {{ accountData.accountUsedCreditAmt }} 元</a-row>
            <a-form-item label="还款方式" v-bind="formItemLayout">
              <a-radio-group v-decorator="['largePayType']" @change="onRadioChange">
                <a-radio :value="2">线下转账</a-radio>
                <!-- <a-radio :value="2">在线支付</a-radio> -->
              </a-radio-group>
            </a-form-item>
            <a-form-item label="还款金额" v-bind="formItemLayout">
              <a-input placeholder="请输入"
                       v-decorator="['amount', { rules: [
                { required: true, message: '请输入还款金额', trigger: 'blur' },
                { pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,7}|0)(?:\.\d{1,2})?$/, message: '请输入正确的金额', trigger: 'blur'},
                { validator: this.checkPrice, trigger: 'blur' }
                ] }]"
              />
            </a-form-item>
            <a-form-item label="上传银行电子回单" v-bind="formItemLayout">
              <div class="upload-box">
                <a-upload
                  :action="uploadFileUrl"
                  :multiple="false"
                  v-decorator="['largeOrderImg',{rules:[{required:true, message: '请上传银行电子回单'}]}]"
                  :showUploadList="false"
                  listType="picture-card"
                  @change="handleChange"
                >
                  <img v-if="imageUrl" :src="imageUrl" alt="avatar" class="selected-image"/>
                  <div v-else>
                    <a-icon type="plus"/>
                    <br>上传
                  </div>
                </a-upload>
              </div>
            </a-form-item>
            <a-form-item v-bind="formItemLayoutBtn">
              <a-button type="primary" htmlType="submit">提交还款</a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="12">
          <h3 style="margin-left:10px;">请向下方账号转账付款并上传转账凭证</h3>
          <div>
            <div class="tr">
              <div class="left-style">账户名:</div>
              {{ bankInfo.bankMan }}
            </div>
            <div class="tr">
              <div class="left-style">银行账号:</div>
              {{ bankInfo.bankAccount }}
            </div>
            <div class="tr">
              <div class="left-style">开户银行:</div>
              {{ bankInfo.bankName }}
            </div>
          </div>
        </a-col>
      </a-row>
      <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',paddingLeft:'0px'}">
        <a-row slot="title">
          <a-col :span="8">
            <span class="card-title">还款记录</span>
          </a-col>
        </a-row>
        <custom-page-table
          ref="table"
          rowKey="largeId"
          :columns="columns"
          :requestPromise="loadPromise"
        >
          <span slot="largeStatus" slot-scope="rowItem">
            {{ rowItem.text|creditPaymentTypeName }}
          </span>
          <span slot="largeBackAmountType" slot-scope="rowItem">
            {{ rowItem.text|transferTypeName }}
          </span>
        </custom-page-table>
      </a-card>
    </a-card>

  </div>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'

export default {
  name: 'BalanceRecharge',
  mixins: [formMixins],
  data() {
    return {
      accountData: {
        accountUsedCreditAmt: 0
      },
      bankInfo: [],
      imageUrl: '',
      loading: false,
      businessFileList: [],
      formItemLayoutBtn: {
        wrapperCol: {
          xxl: { offset: 5 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 8 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 9 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 8 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 11 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 12 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 5 },
          xl: { span: 8 },
          lg: { span: 9 },
          sm: { span: 8 },
          md: { span: 11 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 19 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 16 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 14 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 16 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 13 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 12 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      largePayType: 2,
      queryParams: {},
      loadPromise: params => this.getPaymentData(params),
      columns: [
        {
          title: '提交时间',
          dataIndex: 'largeCreateTime'
        },
        {
          title: '金额(元)',
          dataIndex: 'largeAmount'
        },
        {
          title: '还款方式',
          dataIndex: 'largeBackAmountType',
          scopedSlots: { customRender: 'largeBackAmountType' }
        },
        {
          title: '充值结果',
          dataIndex: 'largeStatus',
          scopedSlots: { customRender: 'largeStatus' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        }
      ]
    }
  },
  mounted() {
    this.form.setFieldsValue({
      largePayType: 2
    })
    this.getAmountData()
    this.getBankInfo()
  },
  methods: {
    //还款金额输入框验证
    checkPrice(rule, value, callback) {
      setTimeout(() => {
        if (Number(value) < 100) {
          callback(new Error('最低还款金额100元'))
        } else if (Number(value) > Number(this.form.validateFields.accountUsedCreditAmt)) {
          callback(new Error('输入金额必须小于待还款金额'))
        } else {
          callback()
        }
      }, 500)
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.imageUrl = url
        this.loading = false
      }
    },
    //表格数据
    getPaymentData(params) {
      return this.getHttpServices().getOrderService().post('largePayment/auth/back/amount/list', {
        limitDto: params,
        merchantId: this.$store.getters.userInfo.merchantId
      })
    },
    //获取商户信息
    getAmountData() {
      const getUrl = 'user/merchantAccount/getMerchantCreditAccount/' + this.$store.getters.userInfo.merchantId
      this.getHttpServices().getUserService().get(getUrl)
        .then(res => {
          this.accountData = res
          this.getLogUtils().logWithTag('授信待还', res)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    //获取银行卡信息
    getBankInfo() {
      this.getHttpServices().getOrderService().post('largePayment/getBankInfoVo').then(res => {
        this.bankInfo = res
        this.getLogUtils().logWithTag('银行卡信息', res)
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    //提交按钮
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.getHttpServices().getOrderService().post('largePayment/orderPaySubmit', {
            largeOrderImg: this.imageUrl,
            largePayType: values.largePayType,
            amount: values.amount,
            largeUserId: this.$store.getters.userInfo.merchantId
          })
            .then(res => {
              this.getLogUtils().logWithTag('================', res)
              this.$message.success('提交还款成功')
              this.$refs.table.refresh()
            }).catch(reason => {
            this.$message.error('提交还款失败')
            this.showNetWorkErrorMessage(reason)
          })
        }
      })
    },
    onRadioChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      this.rechargType = e.target.value
    },
    goAccSetting() {
      this.$router.push({
        name: 'AccountSetting'
      })
    },
    handleBusinessLicenseChange(file) {
    }
  }

}
</script>
<style scoped lang="less">
@import url("../../CustomPage.less");

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.title-name {
  font-size: 15px;
  color: #000;
  padding-left: 4%;
}

.upload-box {
  margin-top: 14px;
  height: 104px;
  position: relative;
}

.selected-image {
  width: 100px;
  height: 100px;
}

.tr {
  font-size: 14px;
  display: flex;
  margin: 20px 0;
}

.left-style {
  width: 70px;
  margin-right: 20px;
  text-align: right;
}

.right-style {
  text-align: left;
  width: 30%;
}
</style>